import React, { useEffect, useRef, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { formatDate } from "../../appconfig/AppHelper";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";

interface Props {
  visible: boolean;
  onHide: () => void;
  timePeriod: any;
  employeeDataPreview: any[];
  globalHours: any;
  userData: any;
  clientData: any;
  submitLoading: boolean;
  client_id: any;
  paycycle_id: any;
  onSubmit: any;
}

const SalaryPreviewVersion2Client: React.FC<Props> = ({ visible, onHide, timePeriod, employeeDataPreview, globalHours, onSubmit, submitLoading }) => {
  // Track edited tax values
  const [editedTaxes, setEditedTaxes] = useState<{
    [key: string]: { federal_tax: any; provincial_tax: any };
  }>({});

  const toast = useRef<any>(null);
  const navigate = useNavigate();

  // get userData from local Storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  // Initialize editable fields when visible or data changes
  useEffect(() => {
    if (visible && employeeDataPreview?.length) {
      const initial = Object.fromEntries(
        employeeDataPreview.map((emp) => [
          emp.user_id,
          {
            federal_tax: emp.federal_tax ?? "",
            provincial_tax: emp.provincial_tax ?? "",
          },
        ]),
      );

      setEditedTaxes(initial);
    }
  }, [visible, employeeDataPreview]);

  // handle change
  const handleTaxChange = (userId: any, field: any, value: any) => {
    setEditedTaxes({
      ...editedTaxes,
      [userId]: { ...editedTaxes[userId], [field]: value },
    });
  };

  // Check if any employee has valid hours
  const hasValidEmployee = employeeDataPreview.some(
    (emp: any) =>
      Number(globalHours?.[emp.id]?.hours) > 0 ||
      Number(globalHours?.[emp.id]?.state_holiday_value) > 0 ||
      globalHours?.[emp.id]?.is_salary == true ||
      globalHours?.[emp.id]?.state_holiday_value != "-",
  );


  const onSubmitTemp = () => {
    onSubmit("submit", editedTaxes);
  };

  return (
    <Sidebar visible={visible} onHide={onHide} fullScreen className="p-sidebar-lg">
      <div className="lg:p-4  bg-white border-round shadow-1">
        <h2 className="p-3 m-0">Salary Preview </h2>

        <div className="p-3 mb-4 ">
          <h5 className="mb-3">Pay Period Information</h5>
          <div className="flex flex-wrap gap-2 text-sm lg:gap-4">
            <div style={{ fontSize: "16px" }}>
              <strong>Pay Period Start:</strong> {formatDate(timePeriod?.start_date)}
            </div>
            <div style={{ fontSize: "16px" }}>
              <strong>Pay Period End:</strong> {formatDate(timePeriod?.end_date)}
            </div>
            <div style={{ fontSize: "16px" }}>
              <strong>Paycheck Date:</strong> {formatDate(timePeriod?.payCheckDate)}
            </div>
          </div>
        </div>

        {/* loop to get employee data  */}
        {hasValidEmployee ? (
          // employeeDataPreview.map((emp: any) => {
          employeeDataPreview
            .filter(
              (emp: any) =>
                Number(emp?.hours) > 0 ||
                Number(emp?.state_holiday_value) > 0 ||
                emp?.is_salary === true ||
                emp?.state_holiday_value != "-",
            )
            .map((emp: any) => {
              return (
                <>
                  <div className="p-3 mb-5 lg:p-4 border-round card shadow-2">
                    <div key={emp?.id}>
                      <h4 className="mb-3">
                        {emp.first_name} {emp.last_name}
                      </h4>

                      {/* Earnings Table */}
                      <div className="mb-4 overflow-x-auto">
                        <h5 className="mb-2 text-base font-large">Earnings</h5>
                        <table className="table-auto preview-table">
                          <thead>
                            <tr>
                              <th className="text-left">Earnings</th>
                              {/* <th className="text-right">Rate {`${emp?.night_rate != "0.00" ? "/ Night Rate" : ""}`}</th> */}
                              <th className="text-right">
                                Rate
                                {emp?.night_rate != "0.00" && <div style={{ fontSize: "14px", color: "gray" }}>( Wage 1 / Wage 2)</div>}
                              </th>
                              <th className="text-right">
                                Hours {emp?.night_rate !== "0.00" && <div style={{ fontSize: "14px", color: "gray" }}>( Wage 1 / Wage 2)</div>}
                              </th>
                              <th className="text-right">This Period</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* Regular */}
                            <tr>
                              <td className="bg-td">Regular</td>

                              {/* Rate */}
                              <td className="text-right">
                                {`$${emp?.rate}${emp?.night_rate !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                  ? ` / $${emp?.night_rate}`
                                  : ""
                                  }`}
                              </td>

                              {/* Hours */}
                              {emp?.is_salary === false ? (
                                <td className="text-right">
                                  {`${emp?.hours}${emp?.night_hours !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                    ? ` / ${emp?.night_hours}`
                                    : ""
                                    }`}
                                </td>
                              ) : (
                                <td className="text-right">-</td>
                              )}

                              <td className="text-right">${emp?.hourly_Salary}</td>
                            </tr>

                            {/* over time pay */}
                            {((emp?.overtime_value !== "0.00" || emp?.overtime_night_value !== "0.00") && (emp?.overtime !== "0.00")) && (
                              <tr>
                                <td className="bg-td">Overtime Pay</td>

                                {/* Rate */}
                                {emp?.is_salary === false ? (
                                  <td className="text-right">
                                    {`$${emp?.overtime_wage}${emp?.overtime_night_wage !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                      ? ` / $${emp?.overtime_night_wage}`
                                      : ""
                                      }`}
                                  </td>
                                ) :
                                  <td className="text-right">
                                    {emp?.overtime ? `$${emp?.overtime}` : "-"}
                                  </td>}

                                {/* Hours */}
                                {emp?.is_salary === false ? (
                                  <><td className="text-right">
                                    {emp?.overtime_value !== "0.00" || emp?.overtime_night_value !== "0.00"
                                      ? `${emp?.overtime_value}${emp?.overtime_night_value !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                        ? ` / ${emp?.overtime_night_value}`
                                        : ""}`
                                      : "-"}
                                  </td></>
                                ) : (
                                  <td className="text-right">-</td>
                                )}
                                <td className="text-right">${emp?.overtime}</td>
                              </tr>
                            )}

                            {/* over time double pay */}
                            {((emp?.overtime_2_value !== "0.00" || emp?.overtime_2_night_value !== "0.00") && (emp?.overtime_2 !== "0.00")) && (
                              <tr>
                                <td className="bg-td">Overtime Double Pay</td>

                                {/* Rate */}
                                {emp?.is_salary === false ? (
                                  <td className="text-right">
                                    {`$${emp?.overtime_2_wage}${emp?.overtime_2_night_wage !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                      ? ` / $${emp?.overtime_2_night_wage}`
                                      : ""
                                      }`}
                                  </td>
                                ) : (
                                  <td className="text-right">
                                    {emp?.overtime_2 ? `$${emp?.overtime_2}` : "-"}
                                  </td>
                                )}

                                {/* Hours */}
                                {emp?.is_salary === false ? (
                                  <td className="text-right">
                                    {emp?.overtime_2_value !== "0.00" || emp?.overtime_2_night_value !== "0.00"
                                      ? `${emp?.overtime_2_value}${emp?.overtime_2_night_value !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                        ? ` / ${emp?.overtime_2_night_value}`
                                        : ""
                                      }`
                                      : "-"}
                                  </td>
                                ) : (
                                  <td className="text-right">-</td>
                                )}
                                <td className="text-right">${emp?.overtime_2}</td>
                              </tr>
                            )}

                            {emp?.bonus_paid === "0.00" ? null : (
                              <tr>
                                <td className="bg-td">Bonus</td>
                                <td className="text-right ">-</td>
                                <td className="text-right ">-</td>
                                <td className="text-right ">${emp?.bonus_paid}</td>
                              </tr>
                            )}

                            {emp?.commision_paid === "0.00" ? null : (
                              <tr>
                                <td className="bg-td">Commission</td>
                                <td className="text-right ">-</td>
                                <td className="text-right ">-</td>
                                <td className="text-right ">${emp?.commision_paid}</td>
                              </tr>
                            )}

                            {emp?.vacation_paid === "0.00" ? null : (
                              <tr>
                                <td className="bg-td">Vacation</td>
                                <td className="text-right ">-</td>
                                <td className="text-right ">-</td>
                                <td className="text-right ">${emp?.vacation_paid}</td>
                              </tr>
                            )}

                            {/* stat holiday */}
                            {((emp?.holiday_hours !== "0.00" || emp?.holiday_night_hours !== "0.00") && (emp?.holiday_Salary !== "0.00")) && (
                              <tr>
                                <td className="bg-td">Stat Holiday</td>

                                {/* Rate */}
                                {emp?.is_salary === false ? (
                                  <td className="text-right">
                                    {`$${emp?.rate}${emp?.night_rate !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                      ? ` / $${emp?.night_rate}`
                                      : ""
                                      }`}
                                  </td>
                                ) : (
                                  <td className="text-right">{emp?.holiday_Salary ? `$${emp?.holiday_Salary}` : "-"}</td>
                                )}

                                {/* Hours */}
                                {emp?.is_salary === false ? (
                                  <td className="text-right">
                                    {emp?.holiday_hours !== "0.00" || emp?.holiday_night_hours !== "0.00"
                                      ? `${emp?.holiday_hours}${emp?.holiday_night_hours !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                        ? ` / ${emp?.holiday_night_hours}`
                                        : ""
                                      }`
                                      : "-"}
                                  </td>
                                ) : (
                                  <td className="text-right">-</td>
                                )}

                                <td className="text-right">{emp?.holiday_Salary ? `$${emp?.holiday_Salary}` : "-"}</td>
                              </tr>
                            )}

                            {/* stat working holiday */}
                            {((emp?.stat_holiday_value !== "0.00" || emp?.stat_holiday_night_value !== "0.00") && (emp?.stat_holiday !== "0.00")) && (
                              <tr>
                                <td className="bg-td">Stat Working Holiday</td>

                                {/* Rate */}
                                {emp?.is_salary === false ? (
                                  <td className="text-right">
                                    {`$${emp?.stat_holiday_wage}${emp?.stat_holiday_night_wage !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                      ? ` / $${emp?.stat_holiday_night_wage}`
                                      : ""
                                      }`}
                                  </td>
                                ) : (
                                  <td className="text-right">{emp?.stat_holiday ? `$${emp?.stat_holiday}` : "-"}</td>
                                )}

                                {/* Hours */}
                                {emp?.is_salary === false ? (
                                  <td className="text-right">
                                    {emp?.stat_holiday_value !== "0.00" || emp?.stat_holiday_night_value !== "0.00"
                                      ? `${emp?.stat_holiday_value}${emp?.stat_holiday_night_value !== "0.00" || (emp?.night_rate !== "0.00" && emp?.night_hours !== "0.00")
                                        ? ` / ${emp?.stat_holiday_night_value}`
                                        : ""
                                      }`
                                      : "-"}
                                  </td>
                                ) : (
                                  <td className="text-right">-</td>
                                )}

                                <td className="text-right">{emp?.stat_holiday ? `$${emp?.stat_holiday}` : "-"}</td>
                              </tr>
                            )}

                            {emp?.tip === "0.00" ? null : (
                              <tr>
                                <td className="bg-td">Tips</td>
                                <td className="text-right ">-</td>
                                <td className="text-right ">-</td>
                                <td className="text-right ">${emp?.tip}</td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <tr className="summary-row">
                              <td className="font-bold">Gross Pay</td>
                              <td colSpan={5} className="font-bold text-right">
                                ${emp?.salary}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>

                      {/* Deductions Table */}
                      <div className="overflow-x-auto">
                        <h5 className="mb-2 text-base font-large">Deductions</h5>
                        <table className="table-auto preview-table">
                          <thead>
                            <tr>
                              <th className="text-left ">Type</th>
                              <th className="text-left "></th>
                              <th className="text-right ">Employer Tax</th>
                              <th className="text-right ">Employee Tax</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="bg-td">CPP</td>
                              <td className="text-right "></td>
                              <td className="text-right ">${emp?.employer_cpp}</td>
                              <td className="text-right ">${emp?.cppTax}</td>
                            </tr>
                            <tr>
                              <td className="bg-td">CPP2</td>
                              <td className="text-right "></td>
                              <td className="text-right ">${emp?.employer_cpp2}</td>
                              <td className="text-right ">${emp?.cpp2Tax}</td>
                            </tr>
                            <tr>
                              <td className="bg-td">EI</td>
                              <td className="text-right"></td>
                              <td className="text-right ">${emp?.employer_ei}</td>
                              <td className="text-right ">${emp?.eiTax}</td>
                            </tr>
                            <tr>
                              <td className="bg-td">Federal</td>
                              <td className="text-right "></td>
                              <td className="text-right "></td>
                              {/* <td className="text-right ">${emp?.federal_tax}</td> */}

                              <td className="text-right " style={{ display: "flex", justifySelf: "end" }}>
                                <div className="w-half">
                                  <form autoComplete="off">
                                    <div className="flex-1 input-effect-div p-inputgroup">
                                      <span className="font-bold p-inputgroup-addon">$</span>
                                      <InputNumber
                                        style={{ minWidth: "50px" }}
                                        value={editedTaxes[emp.user_id]?.federal_tax ?? 0}
                                        onValueChange={(e) => handleTaxChange(emp.user_id, "federal_tax", e.value)}
                                        disabled={userRole === "Client"}
                                        placeholder="Enter tax"
                                        maxFractionDigits={2}
                                        mode="decimal"
                                      />
                                    </div>
                                  </form>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="bg-td">Provincial</td>
                              <td className="text-right "></td>
                              <td className="text-right "></td>
                              {/* <td className="text-right ">
                              ${emp?.provincial_tax}
                            </td> */}

                              <td className="text-right " style={{ display: "flex", justifySelf: "end" }}>
                                <div className="w-half">
                                  <form autoComplete="off">
                                    <div className="flex-1 input-effect-div p-inputgroup">
                                      <span className="font-bold p-inputgroup-addon">$</span>
                                      <InputNumber
                                        style={{ minWidth: "40px" }}
                                        value={editedTaxes[emp.user_id]?.provincial_tax ?? 0}
                                        onValueChange={(e) => handleTaxChange(emp.user_id, "provincial_tax", e.value)}
                                        disabled={userRole === "Client"}
                                        placeholder="Enter provincial tax"
                                        maxFractionDigits={2}
                                        mode="decimal"
                                      />
                                    </div>
                                  </form>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            {emp?.medical_exemption !== "0.00" && (
                              <tr>
                                <td className="bg-td"> Health Benefit</td>
                                <td className="text-right "></td>
                                <td className="text-right "></td>
                                <td className="text-right ">${emp?.medical_exemption}</td>
                              </tr>
                            )}

                            <tr className="summary-row">
                              <td className="font-bold">Net Pay</td>
                              <td className="text-right "></td>
                              <td className="text-right"></td>
                              <td className="font-bold text-right">${emp?.netAmount}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
        ) : (
          <h2 className=" text-center" style={{ color: "red" }}>
            Enter working hour
          </h2>
        )}

        {hasValidEmployee ? (
          <div className="p-3 mb-4">
            <div className="flex justify-content-end gap-2 mt-2">
              <Button
                type="button"
                icon="pi pi-check"
                label="Submit"
                className="p-button-info"
                onClick={onSubmitTemp}
                disabled={submitLoading || !timePeriod?.client_charge}
                loading={submitLoading}
              />
            </div>
          </div>
        ) : null}
      </div>
    </Sidebar>
  );
};

export default SalaryPreviewVersion2Client;
